export const TRANSPORT_RESET = "TRANSPORT_RESET";
export const TRANSPORT_SET_ERROR = "TRANSPORT_SET_ERROR";
export const TRANSPORT_SET_ITEMS = "TRANSPORT_SET_ITEMS";
export const TRANSPORT_TOGGLE_LOADING = "TRANSPORT_TOGGLE_LOADING";
